export const getZoneInteractionProps = () => {
    return {
        action: 'action',
        automatedZone: 'automated_zone',
        ctaLabel: 'cta_label',
        pageName: 'page_name',
        zoneId: 'zone_id',
        zoneLayout: 'zone_layout',
        zoneName: 'zone_name',
        zonePosition: 'zone_position',
        zoneType: 'zone_type'
    };
};
